import { Field } from 'react-final-form';
import Radio from 'components/other/Radio';
import Icon from 'components/other/Icons';

import styles from './TestForm.module.scss';

const EconomicsEducationField = field => (
  <div className={styles.FieldContainer} tabIndex="0">
    <p>Kunden har økonomisk utdannelse</p>
    <Field name="economicsEducation" type="radio" value="true">
      {({ input }) => (
        <label htmlFor="economicsEducation_true">
          <Radio
            id="economicsEducation_true"
            type="radio"
            value="true"
            checked={input.checked}
            onChange={input.onChange}
          />
          Ja
        </label>
      )}
    </Field>
    <Field name="economicsEducation" type="radio" value="false">
      {({ input }) => (
        <label htmlFor="economicsEducation_false">
          <Radio
            id="economicsEducation_false"
            type="radio"
            value="false"
            checked={input.checked}
            onChange={input.onChange}
          />
          Nei
        </label>
      )}
    </Field>
    {field.meta.error && field.meta.touched && (
      <div className={styles.errorContainer}>
        <Icon icon="exclamation-triangle" />
        <span>{field.meta.error}</span>
      </div>
    )}
  </div>
);

export default EconomicsEducationField;
